module.exports = "## Text Field\n\n[Text fields](https://www.google.com/design/spec/components/text-fields.html)\nallow users to input text.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/TextField/README.md
 ** module id = 1083
 ** module chunks = 0
 **/